module.exports = __webpack_public_path__ + "img/bbLogo.472c4f5b.png";